module.exports = __webpack_public_path__ + "images/apps/wechat-565346b996dbe65ce804da1a44d4f153.png";